import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

type Props = {
	isExportMode?: boolean;
};

const Divider = ({ isExportMode = false }: Props) => (
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
	<div aria-hidden className={isExportMode ? styles.dividerExportMode : styles.divider} />
);

export default Divider;
